import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
  AMBULANCE_LIST,
  AMBULANCE_DETAIL,
  AMBULANCE_MAINTENANCE_UPDATE
} from '../actions';
import {
  AmbulanceListSuccess,
  AmbulanceListError,
  AmbulanceDetailSuccess,
  AmbulanceDetailError,
  AmbulanceMaintenanceUpdateSuccess,
  AmbulanceMaintenanceUpdateError
} from '../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onAmbulanceListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'ambulance/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { data: response };
};

const onAmbulanceDetailAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'ambulance/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { data: response };
};

const onAmbulanceMaintenanceUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'ambulance/update', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { message: true, data: response };
};

function* onAmbulanceList(data) {
  try {
    const response = yield call(onAmbulanceListAsync, data.payload);
    yield put(AmbulanceListSuccess(response.data));
  } catch (error) {
    yield put(AmbulanceListError(error));
  }
}

function* onAmbulanceDetail(data) {
  try {
    const response = yield call(onAmbulanceDetailAsync, data.payload);
    yield put(AmbulanceDetailSuccess(response.data.data));
  } catch (error) {
    yield put(AmbulanceDetailError(error));
  }
}

function* onAmbulanceMaintenanceUpdate(data) {
  try {
    const response = yield call(onAmbulanceMaintenanceUpdateAsync, data.payload);
    if (response.data.status === true) {
      NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
    } else if (response.data.status === 'error') {
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
    yield put(AmbulanceMaintenanceUpdateSuccess(response.data));
  } catch (error) {
    yield put(AmbulanceMaintenanceUpdateError(error));
  }
}

export function* watchAmbulanceList() {
  yield takeEvery(AMBULANCE_LIST, onAmbulanceList);
}

export function* watchAmbulanceDetail() {
  yield takeEvery(AMBULANCE_DETAIL, onAmbulanceDetail);
}

export function* watchAmbulanceMaintenanceUpdate() {
  yield takeEvery(AMBULANCE_MAINTENANCE_UPDATE, onAmbulanceMaintenanceUpdate);
}

export default function* rootSaga() {
  yield all([
    fork(watchAmbulanceList),
    fork(watchAmbulanceDetail),
    fork(watchAmbulanceMaintenanceUpdate)
  ]);
}
